import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { getProduto } from 'config/produto-env';
import { useAuth } from 'context/AuthContext';
import { CategoriaPreInscricao, getCategoriasPermitidas, podeCadastrarPreInscricao } from 'utils/pessoa';

interface PreInscricaoRouteProps {
  /** Sem categoria, basta a pessoa poder se inscrever em alguma categoria do produto. */
  categoria?: CategoriaPreInscricao;
  children: ReactNode;
}

/**
 * Libera o cadastro da pré-inscrição só para quem a base de pessoas permite
 * na categoria (programa, inelegibilidade e equipe organizadora). Os demais
 * acessam o site, mas voltam para a home do produto.
 */
export function PreInscricaoRoute({ categoria, children }: PreInscricaoRouteProps) {
  const { user, loadingUserData } = useAuth();

  if (loadingUserData) {
    return null;
  }

  const produto = getProduto();
  const liberado = categoria
    ? podeCadastrarPreInscricao(user?.pessoa, produto, categoria)
    : getCategoriasPermitidas(user?.pessoa, produto).length > 0;
  if (!liberado) {
    return <Navigate to={produto === 'PREMIO_ELBB' ? '/home-elbb' : '/home-public'} replace />;
  }

  return <>{children}</>;
}
